<template>
  <div id="app">
    <!--<img src="./static/logo.png">-->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  body {
    margin: 0;
    padding: 0;
    overflow-y: scroll;
    overflow-x: hidden;
    font-family: roboto,Helvetica Neue,Helvetica,Arial,PingFang SC,SourceHanSansNormal,Hiragino Sans GB,Source Han Sans,Microsoft YaHei,WenQuanYi Micro Hei,sans-serif;
  }
  #app {
  }
</style>

<style>
  .el-menu {
    border-right: 0;
  }

  .el-submenu__title, .el-menu-item {
    font-weight: bold;
    height: 34px;
    line-height: 34px;
    color: rgba(255, 255, 255, .65);
  }

  .el-submenu__title:hover {
    color: white !important;
    /*background: transparent!important;*/
    border-radius: 4px;
  }

  .el-menu-item-group__title {
    padding: 0;
  }

  .el-menu-item-group > ul {
    padding: 5px 0;
  }

  .el-submenu .el-menu-item {
    height: 24px;
    line-height: 24px;
    padding-left: 52px !important;
  }

  .el-submenu .el-menu-item:hover {
    color: white !important;
    background: transparent !important;
  }
</style>
<style>
  .el-breadcrumb__inner a, .el-breadcrumb__inner.is-link {
    font-weight: normal;
    color: #69bdfb;
  }

  .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: rgba(255, 255, 255, .75);
  }

  .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
    font-weight: normal;
    color: rgba(255, 255, 255, .75);
  }

  h1 {
    color: white;
    padding: 0;
    margin: 0;
    font-size: 24px;
    border: none;
    line-height: 32px;
    font-weight: 500;
  }

  h6 {
    color: white;
    padding: 6px 0;
    margin: 0;
  }

  .el-breadcrumb {
    float: right;
    width: auto;
    height: 32px;
    line-height: 32px;
  }

  .card-table {
    background-color: rgba(0, 0, 0, .25);
    border: 0;
    color: white;
  }

  .el-card__header {
    padding: 5px 15px;
    background: #000;
    color: rgba(255, 255, 255, .8);
    border-bottom: 0;
  }

  .el-table {
    color: rgba(255, 255, 255, .6);
    min-height: 486px;
  }

  .el-table, .el-table__expanded-cell {
    background: transparent;
  }

  .el-table::before {
    background: transparent;
  }

  .el-table th, .el-table tr {
    background: transparent;
  }

  .el-table--striped .el-table__body tr.el-table__row--striped td {
    background: rgba(255, 255, 255, .05);
  }

  .el-table td, .el-table th.is-leaf {
    border-bottom: 1px solid rgba(255, 255, 255, .35);
  }

  .el-table__body tr.hover-row > td, .el-table__body tr.hover-row.el-table__row--striped > td {
    background-color: rgba(255, 255, 255, .075);
  }
  .el-table__fixed-right::before, .el-table__fixed::before{
    background: transparent;
  }
  .el-table__fixed-right td {
    border-bottom: 1px solid transparent;
  }
  .el-table__fixed-right .el-table__body tr.el-table__row--striped td {
    background: transparent;
  }
  .el-table tr img{
    width: 32px;
    height: 32px;
    vertical-align:middle;
    object-fit: cover;
  }
  .el-table .el-progress{
    line-height: 0;
  }
  .el-table .el-progress-bar{
    padding-right: 0px;
  }
  .el-table .el-progress__text{
    width: 0px;
    display: none;
  }
  .el-table--enable-row-hover .el-table__body tr:hover>td{
    background: rgba(255,255,255,0.15);
  }
  .el-table__expanded-cell .el-table td, .el-table th.is-leaf{
    border-bottom: 1px solid transparent;
  }
  .el-table--enable-row-hover .el-table__body tr:hover>td{
    border-bottom: 1px solid transparent;
  }
   .el-button {
    color: #000;
    background: #fff;
    border-color: #fff;
    font-weight: 600;
  }

  .el-button:hover {
    background: #eee;
    border-color: #fff;
  }
  .el-button--text {
    color: #409EFF;
    background: 0 0;
    padding-left: 0;
    padding-right: 0;
    border:0;
    min-width: 40px;
  }
  .el-button--text:focus, .el-button--text:hover{
    background: transparent;
    border: 0;
  }
  .el-button--primary {
    color: #fff;
    background: #006cff;
    border-color: #006cff;
  }

  .el-button--primary:hover {
    background: #0051bf;
    border-color: transparent;
  }

  .el-button--success {
    color: #fff;
    background: #04c142;
    border-color: transparent;
  }

  .el-button--success:hover {
    background: #039131;
    border-color: #039131;
  }
  .el-button--danger {
    color: #fff;
    background: #ff3502;
    border-color: #ff3502;
  }
  .el-button--danger:hover {
    background: #bf2801;
    border-color: #bf2801;
  }
  .el-pagination {
    margin-top: 20px;
  }

  .el-pagination .btn-next, .el-pagination .btn-prev {
    color: white;
    background: transparent;
  }

  .el-pagination button:disabled {
    background: transparent;
  }

  .el-pagination__total, .el-pagination__jump {
    color: rgba(255, 255, 255, .6);
  }
  .el-pager li.btn-quicknext, .el-pager li.btn-quickprev{
    color: rgba(255, 255, 255, .6);
  }

  .el-dialog, .el-pager li {
    background: transparent;
    color: white;
  }

  .el-input__inner {
    background: rgba(255, 255, 255, .25);
    border: 1px solid transparent;
    color: #fff;
  }

  .el-textarea__inner {
    background: rgba(255, 255, 255, .25);
    border: 1px solid transparent;
    color: #fff;
  }

  .el-form-item__label {
    color: rgba(255, 255, 255, .75);
    font-weight: 600;
  }

  .el-checkbox, .el-radio {
    color: rgba(255, 255, 255, .75);
  }
  .el-input-number__decrease, .el-input-number__increase{
    background: rgba(255, 255, 255, .25);
    color: white;
  }
  .el-input-number__decrease {
    border-right: 1px solid rgba(0, 0, 0, .25);
  }
  .el-input-number__increase {
    border-left: 1px solid rgba(0, 0, 0, .25);
  }
  .el-alert--dark {
    background: rgba(0,0,0,.25);
    color: #fff;
    margin-bottom: 20px;
  }
  .el-alert .el-form-item{
    margin-bottom: 0;
  }
</style>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }

  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>
<style>
  .el-date-editor .el-range-separator{
    color: #c0c4cc;
  }
  .el-date-editor .el-range-input{
    background: transparent;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue